import { render, staticRenderFns } from "./CreateNewUser.vue?vue&type=template&id=7bd8a9e3"
import script from "./CreateNewUser.vue?vue&type=script&lang=js"
export * from "./CreateNewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports